export const useTokenStore = defineStore("tokenStore", () => {
  // States
  const access = ref({ token: null, delay: 0, exp: 0 });

  // Actions

  function resetAccess() {
    access.value = {
      token: null,
      delay: 0,
      exp: 0,
    };
  }

  return {
    access,
    resetAccess,
  };
});
